import type { FooterProps } from '@/components/footer';

export const defaultProps: Required<FooterProps> = {
  links: [
    {
      modalName: 'privacy-policy.dialog',
      name: 'Datenschutz',
    },
    {
      modalName: 'imprint.dialog',
      name: 'Impressum',
    },
  ],
};
